// src/auth/store.ts
import createStore from "react-auth-kit/createStore";
import refresh from "./refresh";

const getRootDomain = () => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost') return hostname;
  
  const parts = hostname.split('.');
  if (parts.length <= 2) return hostname;
  
  return parts.slice(-2).join('.');
};

const authStore = createStore({
  authName: "authToken",
  authType: "cookie",
  cookieDomain: getRootDomain(),
  cookieSecure: false,
  refresh: refresh,
});

export default authStore;
